export type SSEEvent =
  | { type: 'token'; value: string }
  | { type: 'searching' }
  | { type: 'thinking'; tokens?: number }
  | { type: 'tool'; name: string; status: 'start' | 'end' }
  | { type: 'done' }
  | { type: 'error'; message: string };

export function encodeSSE(event: SSEEvent): string {
  return `data: ${JSON.stringify(event)}\n\n`;
}

export function* parseSSE(chunk: string): Generator<SSEEvent> {
  for (const line of chunk.split('\n')) {
    if (!line.startsWith('data: ')) continue;
    const payload = line.slice(6).trim();
    if (!payload) continue;
    try {
      yield JSON.parse(payload) as SSEEvent;
    } catch {
      // payload malformato, skip silenzioso
    }
  }
}
